export function getPricingLink() {
  return '/pricing'
}
